// extracted by mini-css-extract-plugin
module.exports = {"GlobalStats":"GlobalStats_GlobalStats__cajiD","Content":"GlobalStats_Content__FtEpn","Column":"GlobalStats_Column__3bQVf"};